export default {
  state: () => ({
    promoTypes: [],
  }),

  mutations: {
    SET_PROMO_TYPES(state, value) {
      state.promotionTypes = value
    },
  },

  getters: {
    getPromoTypes: (s) => s.promotionTypes,
  },
}
